
import useGetQueryPagination from "./helper/ueGetPagination";
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetOneQuery from "./helper/useGetOneQuery";
import useUpdateMutation from "./helper/useUpdateMutation";
  
const API = {
  ADD: `contact_us`,
  GET_ALL: `contact_us`,
  DELETE: `contact_us`,
  UPDATE: `contact_us`,

};
const KEY = "contact_us"


export const useGetContactUs = (params?:any) => useGetQueryPagination(KEY, API.GET_ALL,params);
export const useGetOneContactUs = () => useGetOneQuery(KEY, API.GET_ALL);

export const useAddContactUs = () => useAddMutation(KEY, API.ADD);
export const useUpdateContactUs = () => useUpdateMutation(KEY, API.UPDATE,true);

export const useDeleteContactUs = () =>useDeleteMutation(KEY, API.DELETE);
